export default {
    watch: {
        isMultiplayer(val) {
            if (val && this.params) {
                this.params.dictation = false;
                this.paramsArray.forEach(param => {
                    param.dictation = false;
                });
            }
        },
    },
    computed: {
        isMultiplayer() {
            return this.paramsArray?.length > 1;
        },
    },
};
